import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { connect } from 'react-redux';
import {
  getHuggg,
  getRedeemedSegment,
  getVouchers,
  getVoucherExpiry,
  isTestHuggg,
  isTestHugggRedeemed,
  redeemTestHuggg,
  shouldHideProductImageOnVoucherClaimed,
  isBlueHuggg,
  hasVoucherToClaim,
  hasFulfilledVoucher,
  isVoucherV2,
} from 'redux/modules/huggg';
import {
  getDefaultSegmentTerritory,
  getIsFormRedemptionType,
  getIsPin4Type,
  getIsPrepaidCardType,
} from 'redux/modules/selectedSegment';
import {
  getBrandAssets,
  getHasLoaded,
  getIsLoading,
  fetchBrandAssets,
  clearBrandAssets,
} from 'redux/modules/tillo';
import {
  clearError as clearVoucherError,
  generate as generateVoucher,
  getError,
  getIsGenerating,
} from 'redux/modules/voucher';
import { isTilloVoucher } from 'utilities/errorHandling';
import { formatVoucherExpiry } from 'utilities/formatVoucherExpiry';
import {
  getRedeemedSegmentImage,
  shouldUseRedeemedSegmentInformation,
  getVoucherAmount,
} from 'utilities/huggg';
import { getRedemptionMethodID } from 'utilities/redemption';
import CardReveal from './CardReveal';

export const CardContainer = (props) => {
  const {
    clearVoucherError,
    generateVoucher,
    isBlueHuggg,
    huggg,
    onConfirm,
    isTestHuggg,
    redeemTestHuggg,
    fetchBrandAssets,
    hasLoaded,
    vouchers,
    defaultTerritory,
    redeemedSegment,
    voucherExpiry,
    voucherError,
    hasFulfilledVoucher,
    isVoucherV2,
    ...rest
  } = props;

  const [isWaitingForFulfil, setIsWaitingForFulfil] = useState(false);
  const prevVoucherTypeRef = useRef(null);
  const fulfilClaimLockRef = useRef(false);

  const voucher = useMemo(() => {
    return vouchers[0];
  }, [vouchers]);

  const tilloBrand = useMemo(() => {
    return redeemedSegment?.configuration?.tilloBrand;
  }, [redeemedSegment]);

  useEffect(() => {
    if (tilloBrand && !hasLoaded) {
      fetchBrandAssets(tilloBrand);
    }
  }, [tilloBrand, fetchBrandAssets, hasLoaded]);

  useLayoutEffect(() => {
    if (prevVoucherTypeRef.current === 'fulfil' && voucher.type === 'url') {
      window.location.href = voucher.value;
    }
    prevVoucherTypeRef.current = voucher.type;
  }, [voucher.type, voucher.value]);

  const onGenerateVoucher = useCallback(
    (segment, data = undefined) => {
      setIsWaitingForFulfil(true);

      if (onConfirm) {
        onConfirm();
      }

      if (isTestHuggg) {
        redeemTestHuggg();
      }

      clearVoucherError();

      const promise = generateVoucher(
        huggg.id,
        segment?.id,
        getRedemptionMethodID(huggg),
        data,
      );

      if (promise && typeof promise.then === 'function') {
        promise
          .then((responseData) => {
            const firstVoucher = responseData?.vouchers?.[0];

            if (firstVoucher?.type === 'url' && firstVoucher?.value) {
              window.location.href = firstVoucher.value;
            }
          })
          .finally(() => {
            setIsWaitingForFulfil(false);
            fulfilClaimLockRef.current = false;
          });
      }
    },
    [
      onConfirm,
      isTestHuggg,
      redeemTestHuggg,
      clearVoucherError,
      generateVoucher,
      huggg,
    ],
  );

  const handleGenerateVoucher = useCallback(() => {
    if (redeemedSegment) {
      onGenerateVoucher(redeemedSegment, { territory: defaultTerritory });
    }
  }, [redeemedSegment, defaultTerritory, onGenerateVoucher]);

  const handleClaimCard = useCallback(() => {
    if (isWaitingForFulfil || fulfilClaimLockRef.current) {
      return;
    }

    const types = voucher.type.split('/');

    setIsWaitingForFulfil(true);

    if (types[0] === 'fulfil') {
      fulfilClaimLockRef.current = true;
      handleGenerateVoucher();
    } else if (types[0] === 'url') {
      window.location.href = voucher.value;
    }
  }, [voucher, handleGenerateVoucher, isWaitingForFulfil]);

  const isFulfilled = hasFulfilledVoucher;

  const redeemedSegmentImage = shouldUseRedeemedSegmentInformation(huggg)
    ? getRedeemedSegmentImage(huggg)
    : null;

  const formattedVoucherExpiry =
    voucherExpiry && (!isVoucherV2 || isFulfilled)
      ? formatVoucherExpiry(voucherExpiry, 'do MMM yyyy', huggg)
      : null;

  const variantLabel = huggg.purchase?.variant_label;
  const brandName = redeemedSegment?.name;
  const isTillo = isTilloVoucher(redeemedSegment?.voucherType);
  const voucherAmount = getVoucherAmount({
    pence: huggg.purchase?.sale_price,
    isGiftCard: true,
    variantLabel,
    alwaysShowDecimal: true,
  });

  const ctaTitle = !isFulfilled ? dictionary.cardReveal.ctaTitle : undefined;

  const processedVoucherLabel = voucher.label?.includes('[type]')
    ? voucher.label.replace('[type]', isBlueHuggg ? 'voucher' : 'card')
    : voucher.label;

  return (
    <CardReveal
      huggg={huggg}
      voucher={voucher}
      isBlueHuggg={isBlueHuggg}
      redeemedSegment={redeemedSegment}
      redeemedSegmentImage={redeemedSegmentImage}
      brandName={brandName}
      voucherAmount={voucherAmount}
      formattedVoucherExpiry={formattedVoucherExpiry}
      processedVoucherLabel={processedVoucherLabel}
      isWaitingForFulfil={isWaitingForFulfil}
      onClaimCard={handleClaimCard}
      voucherError={voucherError}
      isTilloVoucher={isTillo}
      hugggBrandName={huggg.brand_name}
      ctaTitle={ctaTitle}
      {...rest}
    />
  );
};

CardContainer.propTypes = {
  clearVoucherError: PropTypes.func.isRequired,
  generateVoucher: PropTypes.func.isRequired,
  huggg: PropTypes.object.isRequired,
  isTestHuggg: PropTypes.bool.isRequired,
  isTestHugggRedeemed: PropTypes.bool.isRequired,
  redeemTestHuggg: PropTypes.func.isRequired,
  redeemedSegment: PropTypes.object,
  voucherExpiry: PropTypes.string,
  hasFulfilledVoucher: PropTypes.bool,
  isVoucherV2: PropTypes.bool,
  onConfirm: PropTypes.func,
  isBlueHuggg: PropTypes.bool.isRequired,
  fetchBrandAssets: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  brandAssets: PropTypes.object.isRequired,
  clearBrandAssets: PropTypes.func.isRequired,
  voucherError: PropTypes.object,
};

const mapStateToProps = (state) => {
  const huggg = getHuggg(state);

  return {
    brandAssets: getBrandAssets(state),
    hasLoaded: getHasLoaded(state),
    isLoading: getIsLoading(state),
    isFormRedemptionType: getIsFormRedemptionType(state),
    isPin4Type: getIsPin4Type(state),
    isPrepaidCardType: getIsPrepaidCardType(state),
    defaultTerritory: getDefaultSegmentTerritory(state),
    isGenerating: getIsGenerating(state),
    isTestHuggg: isTestHuggg(state),
    isTestHugggRedeemed: isTestHugggRedeemed(state),
    vouchers: getVouchers(state),
    voucherError: getError(state),
    voucherExpiry: getVoucherExpiry(state),
    hideProductImage: shouldHideProductImageOnVoucherClaimed(state),
    redeemedSegment: getRedeemedSegment(state),
    isBlueHuggg: isBlueHuggg(state),
    huggg,
    hasVoucherToClaim: hasVoucherToClaim(state),
    hasFulfilledVoucher: hasFulfilledVoucher(state),
    isVoucherV2: isVoucherV2(state),
  };
};

export default connect(mapStateToProps, {
  clearVoucherError,
  generateVoucher,
  redeemTestHuggg,
  fetchBrandAssets,
  clearBrandAssets,
})(CardContainer);
